const ABSOLUTE_URL_REGEX = /^(?:[a-z+]+:)?\/\//i

/**
 * Checks if a URL is absolute (starts with protocol or //)
 */
export const isAbsoluteUrl = (url?: string): boolean => {
  if (!url) return false
  return ABSOLUTE_URL_REGEX.test(url)
}

/**
 * Builds a URL with query parameters
 */
export const buildUrlWithParams = (
  baseUrl: string,
  params: URLSearchParams,
  defaultParams: string
): string => {
  const url = new URL(baseUrl)
  const hasUtmParams = params.has('utm_campaign')
  const hasExistingUtmParams = url.searchParams.has('utm_campaign')

  const queryString =
    hasUtmParams || hasExistingUtmParams
      ? `?${params.toString()}`
      : defaultParams

  return `${baseUrl}${queryString}`.replace(/\?$/, '')
}
